import React from 'react';
import ContentLoader from 'react-content-loader';

const TopRatingLoader = () => (
	<ContentLoader
		speed={2}
		width='100%'
		height={200}
		viewBox='0 0 700 200'
		backgroundColor='#f3f3f3'
		foregroundColor='#ecebeb'>
		{/* Rating text */}
		<rect x='20' y='20' rx='3' ry='3' width='100' height='20' />

		{/* Main Rating */}
		<rect x='20' y='50' rx='3' ry='3' width='50' height='30' />
		<rect x='80' y='50' rx='3' ry='3' width='70' height='20' />
		<rect x='20' y='90' rx='3' ry='3' width='80' height='15' />

		{/* Star rating distribution */}
		<rect x='250' y='20' rx='3' ry='3' width='150' height='20' />
		<rect x='250' y='50' rx='3' ry='3' width='150' height='20' />
		<rect x='250' y='80' rx='3' ry='3' width='150' height='20' />
		<rect x='250' y='110' rx='3' ry='3' width='150' height='20' />
		<rect x='250' y='140' rx='3' ry='3' width='150' height='20' />

		{/* Rating bars */}
		<rect x='450' y='25' rx='3' ry='3' width='200' height='10' />
		<rect x='450' y='55' rx='3' ry='3' width='200' height='10' />
		<rect x='450' y='85' rx='3' ry='3' width='200' height='10' />
		<rect x='450' y='115' rx='3' ry='3' width='200' height='10' />
		<rect x='450' y='145' rx='3' ry='3' width='200' height='10' />

		{/* Photos and sort options */}
		<rect x='20' y='170' rx='3' ry='3' width='70' height='20' />
		<rect x='100' y='170' rx='3' ry='3' width='40' height='20' />
		<rect x='150' y='170' rx='3' ry='3' width='40' height='20' />
		<rect x='200' y='170' rx='3' ry='3' width='40' height='20' />
		<rect x='250' y='170' rx='3' ry='3' width='40' height='20' />
		<rect x='300' y='170' rx='3' ry='3' width='40' height='20' />
		<rect x='570' y='170' rx='3' ry='3' width='80' height='20' />
	</ContentLoader>
);

export default TopRatingLoader;
